import React, { RefObject } from "react";
import { Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

interface CarouselArrowsProps {
  carouselRef: RefObject<any>;
}

const CarouselArrows: React.FC<CarouselArrowsProps> = ({ carouselRef }) => {
  const handlePrev = () => {
    carouselRef.current.prev();
  };

  const handleNext = () => {
    carouselRef.current.next();
  };

  return (
    <div style={{display:"flex",width:"100%", justifyContent:"flex-end", marginTop: 16 }}>
      <Button style={{margin:2}} onClick={handlePrev}>
        <LeftOutlined />
      </Button>
      <Button style={{margin:2}} onClick={handleNext}>
        <RightOutlined />
      </Button>
    </div>
  );
};

export default CarouselArrows;
